import { render } from "./UserDetails.vue?vue&type=template&id=0e228b40"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"

import "./UserDetails.vue?vue&type=style&index=0&id=0e228b40&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__